(() => {
    const SELECTORS = {
        overlay: "[data-drawer-overlay]",
        close: "[data-drawer-close]",
        content: "[data-drawer-content]",
        footer: "[data-drawer-footer]",
        item: "[data-line]",
        qtyMinus: "[data-qty-minus]",
        qtyPlus: "[data-qty-plus]",
        qtyInput: "[data-qty-input]",
        remove: "[data-remove]",
        urgency: "[data-urgency]",
        urgencyFill: "[data-urgency-fill]",
        savingsWrap: "[data-cart-savings]",
        savingsAmount: "[data-savings-amount]",
    };

    const GIFT_WRAP_VARIANT_ID = 52550245974330;
    const JEWEL_BOX_PRODUCT_ID = 10118668452154;

    /* 3-7-26 offer change start — selective checkout */
    const SELECTIVE_STORAGE_KEY = 'kymee-unselected-items';

    function getUnselectedIds() {
        try { return new Set(JSON.parse(localStorage.getItem(SELECTIVE_STORAGE_KEY) || '[]')); }
        catch { return new Set(); }
    }

    function saveUnselectedIds(drawer) {
        const ids = [];
        drawer.querySelectorAll('[data-line]').forEach(item => {
            const cb = item.querySelector('[data-item-check]');
            if (cb && !cb.checked) {
                const vid = String(item.dataset.productVariantId || '');
                if (vid) ids.push(vid);
            }
        });
        try { localStorage.setItem(SELECTIVE_STORAGE_KEY, JSON.stringify(ids)); } catch {}
    }

    function initCheckboxes(drawer) {
        const unselectedIds = getUnselectedIds();
        const items = [...drawer.querySelectorAll('[data-line]')];
        const currentIds = new Set();

        items.forEach(item => {
            const cb = item.querySelector('[data-item-check]');
            if (!cb) return;
            const vid = String(item.dataset.productVariantId || '');
            currentIds.add(vid);
            cb.checked = !unselectedIds.has(vid);
        });

        // Remove stale IDs from localStorage (items no longer in cart)
        const cleaned = [...unselectedIds].filter(id => currentIds.has(id));
        if (cleaned.length !== unselectedIds.size) {
            try { localStorage.setItem(SELECTIVE_STORAGE_KEY, JSON.stringify(cleaned)); } catch {}
        }

        updateSelectivePrices(drawer);
    }

    function updateSelectivePrices(drawer) {
        const items = [...drawer.querySelectorAll('[data-line]')];

        /* Use original_line_price (before Shopify automatic tier discount) so our
           footer matches GoKwik exactly — Shopify recalculates the discount when
           items are removed from cart, so final_line_price would be stale. */
        let origTotal = 0;
        let eligCount = 0;
        let eligOrig  = 0;

        items.forEach(item => {
            const cb = item.querySelector('[data-item-check]');
            const checked = !cb || cb.checked;
            item.classList.toggle('is-unselected', !checked);
            if (!checked) return;
            const orig = parseInt(item.dataset.originalLinePrice || 0, 10);
            origTotal += orig;
            if (item.dataset.excluded !== 'true') {
                const qty = parseInt(item.querySelector('[data-qty-input]')?.value || 1, 10);
                eligCount += qty;
                eligOrig += orig;
            }
        });

        const pct = eligCount >= 2 ? 20 : eligCount === 1 ? 10 : 0;
        const discountAmt = Math.floor(eligOrig * pct / 100);
        const totalPayable = origTotal - discountAmt;

        const fmt = v => '₹' + Math.floor(v / 100).toLocaleString('en-IN');

        const actualEl   = drawer.querySelector('[data-selective-actual]');
        const discountEl = drawer.querySelector('[data-selective-discount]');
        const discRowEl  = drawer.querySelector('[data-selective-discount-row]');
        const tierLabel  = drawer.querySelector('[data-selective-tier-label]');
        const totalEl    = drawer.querySelector('[data-selective-total]');

        if (actualEl)   actualEl.textContent   = fmt(origTotal);
        if (discountEl) discountEl.textContent = '-' + fmt(discountAmt);
        if (discRowEl)  discRowEl.style.display = pct > 0 ? '' : 'none';
        if (tierLabel)  tierLabel.textContent   = `Discount (${pct}%Off)`;
        if (totalEl)    totalEl.textContent     = fmt(totalPayable);

        /* 3-7-26: update per-item price to reflect active tier discount */
        // items.forEach(item => {
        //     const cb = item.querySelector('[data-item-check]');
        //     const checked = !cb || cb.checked;
        //     const priceEl = item.querySelector('.kymee-item__price');
        //     if (!priceEl) return;
        //     const orig = parseInt(item.dataset.originalLinePrice || 0, 10);
        //     const displayPrice = (!checked || item.dataset.excluded === 'true')
        //         ? orig
        //         : orig - Math.floor(orig * pct / 100);
        //     const strongEl = priceEl.querySelector('strong:not(.kymee-item__price--free)');
        //     let sEl = priceEl.querySelector('s');
        //     if (strongEl) strongEl.textContent = fmt(displayPrice);
        //     if (displayPrice < orig) {
        //         if (!sEl) {
        //             sEl = document.createElement('s');
        //             priceEl.insertBefore(sEl, strongEl);
        //         }
        //         sEl.textContent = fmt(orig);
        //         sEl.style.display = '';
        //     } else if (sEl) {
        //         sEl.style.display = 'none';
        //     }
        // });

        // Sync select-all checkbox
        const hasCheckboxItems = items.some(i => i.querySelector('[data-item-check]'));
        if (hasCheckboxItems) {
            const allChecked = items.every(i => {
                const cb = i.querySelector('[data-item-check]');
                return !cb || cb.checked;
            });
            const selectAll = drawer.querySelector('[data-select-all]');
            if (selectAll) selectAll.checked = allChecked;
        }

        // Update urgency bar based on selected eligible count
        const wrap = drawer.querySelector('[data-urgency]');
        if (wrap) {
            const newStep = eligCount >= 2 ? 2 : eligCount >= 1 ? 1 : 0;
            const discountedCount = parseInt(wrap.dataset.discountedCount || 0, 10);
            wrap.dataset.step = String(newStep);
            wrap.classList.toggle('is-hidden', newStep === 0 && discountedCount === 0);
            const textEl = wrap.querySelector('[data-urgency-text]');
            if (textEl) {
                if (newStep === 0)
                    textEl.innerHTML = 'Add items to unlock exciting discounts';
                else if (newStep === 1)
                    textEl.innerHTML = 'Add <b>1</b> more item to unlock <b>20% Off</b>';
                else
                    textEl.innerHTML = 'Congratulations! 🎉 You unlocked <b>20% Off</b>';
            }
            wrap.querySelectorAll('.kymee-step').forEach((el, i) => {
                if (i === 0) return;
                el.classList.toggle('is-active', newStep >= i);
                el.classList.toggle('is-locked', newStep < i);
            });
            Urgency.render(drawer);
        }

        // Disable "Secure Checkout" the moment nothing is selected at all.
        // Jewel-Box-only selection is intentionally NOT excluded here — the
        // button stays enabled so the click goes through, and it's
        // _footerCheckoutIntercept (below) that blocks the click + shows the
        // "Jewel Box cannot be purchased alone" popup in that case. Excluding
        // it here too would disable the button and the popup could never
        // open, since disabled buttons don't fire click events.
        const hasSellableSelection = items.some(item => {
            const cb = item.querySelector('[data-item-check]');
            return !cb || cb.checked;
        });
        enforceCheckoutButtonState(drawer, hasSellableSelection);
    }

    /* gokwik.liquid re-enables .gokwik-checkout button asynchronously
       (on gokwikLoaded / kymee:cart:added / cart:updated) purely based on
       whether the cart has items — it has no idea about per-item selection,
       so it can stomp on the disable we just applied above a few hundred ms
       later. Rather than relying on gokwik.liquid to stay in sync (it keeps
       getting hand-edited back to the simple version), keep the desired
       state on the button itself and use a MutationObserver to instantly
       re-correct it if anything else changes `disabled`/`class`. */
    function enforceCheckoutButtonState(drawer, shouldEnable) {
        drawer.querySelectorAll('.gokwik-checkout button').forEach(btn => {
            btn.dataset.kymeeEnable = shouldEnable ? '1' : '0';
            applyButtonState(btn);

            if (!btn._kymeeStateObserved) {
                btn._kymeeStateObserved = true;
                new MutationObserver(() => applyButtonState(btn))
                    .observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });
            }
        });
    }

    function applyButtonState(btn) {
        const shouldEnable = btn.dataset.kymeeEnable === '1';
        const shouldBeDisabled = !shouldEnable;
        if (btn.disabled !== shouldBeDisabled) btn.disabled = shouldBeDisabled;
        // Use our own class (not `.disabled`) so we don't trigger gokwik.liquid's
        // `.disabled .addloadr#btn-loader { display: flex }` loading-spinner CSS —
        // that spinner should only show while GoKwik itself is loading, not while
        // the button is merely disabled due to no item being selected.
        if (btn.classList.contains('kymee-checkout-disabled') !== shouldBeDisabled) {
            btn.classList.toggle('kymee-checkout-disabled', shouldBeDisabled);
        }
    }
    /* 3-7-26 offer change end */

    function showCartToast(drawer, message) {
        const panel = drawer?.querySelector('.kymee-drawer__panel_wrapper') || drawer;
        const existing = panel?.querySelector('.kymee-cart-toast-overlay');
        if (existing) existing.remove();

        const overlay = document.createElement('div');
        overlay.className = 'kymee-cart-toast-overlay';

        overlay.innerHTML = `
            <div class="kymee-cart-toast">
                <button class="kymee-cart-toast__close" aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1l10 10M11 1L1 11" stroke="#888" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="kymee-cart-toast__top-bar"></div>
                <svg class="kymee-cart-toast__icon" width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="#1a1a1a" stroke-width="1.8"/>
                    <path d="M12 7v5.5" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/>
                    <circle cx="12" cy="16.5" r="1" fill="#1a1a1a"/>
                </svg>
                <p class="kymee-cart-toast__msg">${message}</p>
            </div>`;

        panel?.appendChild(overlay);
        requestAnimationFrame(() => overlay.classList.add('is-visible'));

        const dismiss = () => {
            overlay.classList.remove('is-visible');
            setTimeout(() => overlay.remove(), 350);
        };

        overlay.querySelector('.kymee-cart-toast__close')?.addEventListener('click', dismiss);
        setTimeout(dismiss, 5000);
    }

    function isOnlyGiftWrap(cart) {
        return (
            cart.items.length === 1 &&
            cart.items[0].variant_id === GIFT_WRAP_VARIANT_ID
        );
    }

    function calculateCartSavings(cart) {
        if (!cart || !cart.items) return 0;
        return (
            cart.items.reduce((sum, item) => {
                return sum + Math.max(0, item.original_line_price - item.final_line_price);
            }, 0) / 100
        );
    }

    function toggleEmptyState(container, cart) {
        const nonEmpty = container.querySelector('[data-cart-non-empty]');
        const wearWithIt = container.querySelector('[data-wear-with-it]');
        const isEmpty = cart.item_count === 0 || isOnlyGiftWrap(cart);
        if (nonEmpty) nonEmpty.style.display = isEmpty ? 'none' : '';
        if (wearWithIt) wearWithIt.style.display = isEmpty ? 'none' : '';
    }

    function updateCartCountBubble(cart) {
        if (!cart) return;
        const count = cart.item_count || 0;
        const update = () => {
            const bubbles = document.querySelectorAll('.cart-count-bubble');
            const navCounts = document.querySelectorAll('[data-cart-count]');
            if (!bubbles.length && !navCounts.length) return false;
            bubbles.forEach((bubble) => {
                const visible = bubble.querySelector('span[aria-hidden]');
                const hidden = bubble.querySelector('.visually-hidden');
                if (visible) visible.textContent = count;
                if (hidden) hidden.textContent = `${count} items`;
                bubble.classList.toggle('hidden', count === 0);
            });
            navCounts.forEach((el) => {
                el.textContent = count;
                el.classList.toggle('show', count > 0);
            });
            document.querySelectorAll('[data-bag-count]').forEach((el) => {
                el.textContent = `(${count})`;
            });
            return true;
        };
        if (!update()) setTimeout(update, 120);
    }

    function syncGiftWrapCheckboxFromCart(cart, container) {
        const checkbox = container.querySelector('[data-gift-wrap-checkbox]');
        const wrapper = checkbox?.closest('[data-gift-wrap-wrapper]') || checkbox?.closest('.kymee-giftwrap-pill');
        if (!checkbox) return;
        const hasGiftWrap = cart.items.some(item => item.variant_id === GIFT_WRAP_VARIANT_ID);
        wrapper?.classList.toggle('is-active', hasGiftWrap);
        checkbox.checked = hasGiftWrap;
        checkbox.setAttribute('aria-checked', hasGiftWrap ? 'true' : 'false');
    }

    async function removeGiftWrapIfOnlyItem(cart) {
        if (
            cart.items.length === 1 &&
            cart.items[0].variant_id === GIFT_WRAP_VARIANT_ID
        ) {
            await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: cart.items[0].key, quantity: 0 }),
            });
            return true;
        }
        return false;
    }

    /* ── Recently Viewed ─────────────────────────────────────── */

    async function renderRecentlyViewed(container) {
        const el = container.querySelector("[data-recently-viewed]");
        if (!el) return;
        const list = JSON.parse(localStorage.getItem("kymee-recently-viewed") || "[]");
        if (!list.length) {
            el.innerHTML = '<p class="kymee-accordion__empty-msg">No recently viewed products</p>';
            return;
        }
        el.innerHTML = `<div class="kymee-wishlist-loading"><span class="kymee-spinner kymee-spinner--lg"></span></div>`;
        const SECTION = "kymee-drawer-rv";
        const results = await Promise.all(
            list.slice(0, 6).map(async (item) => {
                const handle = (item.url || "").split("/products/")[1]?.split("?")[0]?.split("#")[0];
                if (!handle) return { item, cardHtml: null };
                try {
                    const res = await fetch(`/products/${handle}?sections=${SECTION}`);
                    if (!res.ok) throw new Error();
                    const data = await res.json();
                    return { item, cardHtml: data[SECTION] || null };
                } catch { return { item, cardHtml: null }; }
            })
        );
        const cards = results.map(({ item, cardHtml }) => {
            const inner = cardHtml ?? `
                <div class="card-wrapper product-card-wrapper">
                    <a href="${item.url || "#"}" style="display:block">
                        <img src="${item.img || ""}" alt="${item.title || ""}" loading="lazy" style="width:100%;border-radius:8px">
                        <div style="padding:6px 4px;font-size:12px">${item.title || ""}</div>
                        <div style="padding:0 4px 6px;font-size:12px;color:#666">${item.price || ""}</div>
                    </a>
                </div>`;
            return `<li class="kymee-drawer-wl-card">${inner}</li>`;
        });
        el.innerHTML = `<ul class="kymee-wear-with-it_ul kymee-rv-list">${cards.join("")}</ul>`;
        // Products async load hone ke baad scroll initialize karo
        // (pehle initDragScrolls tab run hota tha jab .kymee-rv-list exist hi nahi karta tha)
        setTimeout(initDragScrolls, 50);
        // card_product.js's global MutationObserver only checks each directly-added
        // node's OWN classList (not descendants, for perf) — the injected <ul> itself
        // isn't .card-product-swiper, so it never sees these cards. Call it directly,
        // same as infinite_product_scroll.js does after its own AJAX append.
        if (typeof initCardSwiperTouch === "function") setTimeout(initCardSwiperTouch, 50);
    }

    function renderRecentlyViewedIfOpen(container) {
        const el = container.querySelector("[data-recently-viewed]");
        const accordion = el?.closest("[data-accordion]");
        if (accordion?.classList.contains("is-open")) renderRecentlyViewed(container);
    }

    /* ── Wishlist Tab ────────────────────────────────────────── */

    async function renderWishlistTab(container) {
        const el = container.querySelector("[data-wishlist-content]");
        if (!el) return;
        const list = JSON.parse(localStorage.getItem("wishlist") || "[]");
        if (!list.length) {
            el.innerHTML = `<div class="kymee-wishlist-empty">
                <p>Your wishlist is empty</p>
                <a href="/collections/best-seller" class="kymee-btn kymee-btn--ghost" style="margin-top:12px;width:auto;padding:8px 20px;">Explore Products</a>
            </div>`;
            return;
        }
        el.innerHTML = `<div class="kymee-wishlist-loading"><span class="kymee-spinner kymee-spinner--lg"></span></div>`;
        const SECTION = "kymee-drawer-wishlist";
        const results = await Promise.all(list.map(async (item) => {
            const handle = (item.productUrl || "").split("/products/")[1]?.split("?")[0]?.split("#")[0];
            if (!handle) return { item, cardHtml: null };
            try {
                const res = await fetch(`/products/${handle}?sections=${SECTION}`);
                if (!res.ok) throw new Error();
                const data = await res.json();
                return { item, cardHtml: data[SECTION] || null };
            } catch { return { item, cardHtml: null }; }
        }));
        const cards = results.map(({ item, cardHtml }) => {
            const inner = cardHtml ?? `
                <div class="card-wrapper product-card-wrapper">
                    <div class="kymee-drawer-wl-fallback">
                        <a href="${item.productUrl || "#"}">
                            <img src="${item.productImg || ""}" alt="${item.productTitle || ""}" loading="lazy">
                        </a>
                        <div class="kymee-drawer-wl-fallback__info">
                            <a href="${item.productUrl || "#"}">${item.productTitle || ""}</a>
                            <span>${item.productPrice || ""}</span>
                        </div>
                    </div>
                </div>`;
            return `<div class="kymee-drawer-wl-card">${inner}</div>`;
        });
        el.innerHTML = `<div class="kymee-wishlist-grid">${cards.join("")}</div>`;
    }

    /* ── Confetti ────────────────────────────────────────────── */

    let kymeeConfettiRunning = false;
    let kymeeConfettiLastFired = 0;
    const CONFETTI_COOLDOWN_MS = 3000;

    function fireCanvasConfetti() {
        const now = Date.now();
        if (kymeeConfettiRunning || (now - kymeeConfettiLastFired) < CONFETTI_COOLDOWN_MS) return;
        kymeeConfettiRunning = true;
        kymeeConfettiLastFired = now;

        const canvas = document.getElementById("confetti");
        if (!canvas) { kymeeConfettiRunning = false; return; }

        const ctx = canvas.getContext("2d");
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        const colors = [
            "#FFD700", "#D4AF37", "#E8C27D", "#F5E6C8", "#C9A24D", "#B89B5E", "#FFECB3",
            "#6A0DAD", "#1F3C88", "#0F4C5C", "#006D5B", "#8B0000",
            "#FF6F91", "#FF9671", "#FFC75F", "#F9F871", "#CDB4DB",
            "#00B4D8", "#90DBF4", "#F15BB5", "#9B5DE5", "#4D96FF",
        ];

        const confettis = Array.from({ length: 180 }, () => ({
            x: Math.random() * canvas.width, y: -20,
            size: Math.random() * 5 + 4,
            color: colors[Math.floor(Math.random() * colors.length)],
            speedX: Math.random() * 3 - 1.5,
            speedY: Math.random() * 5 + 2.5,
            rotation: Math.random() * 360,
        }));

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let i = confettis.length - 1; i >= 0; i--) {
                const c = confettis[i];
                c.x += c.speedX; c.y += c.speedY; c.rotation += c.speedX;
                ctx.save();
                ctx.translate(c.x, c.y);
                ctx.rotate((c.rotation * Math.PI) / 180);
                ctx.fillStyle = c.color;
                ctx.fillRect(-c.size / 2, -c.size / 2, c.size, c.size);
                ctx.restore();
                if (c.y > canvas.height + 20) confettis.splice(i, 1);
            }
            if (confettis.length > 0) requestAnimationFrame(animate);
            else { ctx.clearRect(0, 0, canvas.width, canvas.height); kymeeConfettiRunning = false; }
        }
        animate();
    }

    /* ── Urgency Bar ─────────────────────────────────────────── */

    const Urgency = {
        rafId: null,

        stop() {
            if (this.rafId) cancelAnimationFrame(this.rafId);
            this.rafId = null;
        },

        getPercent(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            const fill = wrap?.querySelector(SELECTORS.urgencyFill);
            if (!wrap || !fill) return 0;
            const inline = parseFloat(fill.style.width);
            if (!Number.isNaN(inline)) return inline;
            const bar = fill.parentElement;
            if (!bar) return 0;
            const barW = bar.getBoundingClientRect().width || 1;
            const fillW = fill.getBoundingClientRect().width || 0;
            return Math.max(0, Math.min(100, (fillW / barW) * 100));
        },

        // Bar fill based on eligible item count (step from liquid) — Buy 1 = 10% (50%), Buy 2 = 20% (100%)
        getTarget(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            if (!wrap) return 0;
            const step = parseInt(wrap.dataset.step, 10) || 0;
            if (step >= 2) return 100;
            if (step >= 1) return 50;
            return 0;
        },

        paintDots(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            if (!wrap) return;
            const step = parseInt(wrap.dataset.step, 10) || 0;
            wrap.querySelectorAll(".dot").forEach((dot, i) => {
                let active;
                if (i === 0) active = step >= 1;
                else if (i === 1) active = step >= 1; // center dot at 50% position — activates with first item
                else active = step >= 2;              // fire dot — activates when 20% off unlocked
                dot.classList.toggle("active", active);
            });
        },

        animate(fill, from, to, duration = 420) {
            this.stop();
            const start = performance.now();
            const frame = (now) => {
                const t = Math.min((now - start) / duration, 1);
                const eased = 1 - Math.pow(1 - t, 3);
                const value = from + (to - from) * eased;
                fill.style.width = value.toFixed(2) + "%";
                if (t < 1) this.rafId = requestAnimationFrame(frame);
            };
            this.rafId = requestAnimationFrame(frame);
        },

        render(container, fromOverride = null) {
            const wrap = container.querySelector(SELECTORS.urgency);
            const fill = wrap?.querySelector(SELECTORS.urgencyFill);
            if (!wrap || !fill) return;

            const target = this.getTarget(container);
            this.paintDots(container);

            const from = typeof fromOverride === "number"
                ? fromOverride
                : this.getPercent(container);

            // Fire GTM/confetti every time Shopify applies MORE discount than before —
            // whether that's from "Add to cart" or bumping the qty stepper inside the drawer.
            const discountedCount = parseInt(wrap.dataset.discountedCount, 10) || 0;
            const prev = this._prevDiscountedCount || 0;
            const step = parseInt(wrap.dataset.step, 10) || 0;

            if (discountedCount > prev) {
                document.dispatchEvent(
                    new CustomEvent("kymee:discount:urgency", {
                        detail: { step, percent: target },
                    })
                );
            }

            this._prevDiscountedCount = discountedCount;

            if (Math.abs(from - target) > 0.5) {
                this.animate(fill, from, target);
            } else {
                this.stop();
                fill.style.width = target + "%";
            }
        },
    };

    /* ── Remove Modal ────────────────────────────────────────── */

    const KymeeRemoveModal = (() => {
        let drawerRef = null;
        let pendingLine = null;

        function getModal() { return document.getElementById("kymee-remove-modal"); }
        function getWishlistBtn(modal) { return modal?.querySelector(".wishlist_button"); }

        function fillWishlist(row) {
            const modal = getModal();
            const wishlistBtn = getWishlistBtn(modal);
            if (!wishlistBtn || !row) return;
            wishlistBtn.dataset.productId = row.dataset.productId || "";
            wishlistBtn.dataset.productTitle = row.dataset.productTitle || "";
            wishlistBtn.dataset.productImg = row.dataset.productImg || "";
            wishlistBtn.dataset.productPrice = row.dataset.productPrice || "";
            wishlistBtn.dataset.productUrl = row.dataset.productUrl || "";
            wishlistBtn.dataset.productVariantId = row.dataset.productVariantId || "";
            wishlistBtn.classList.remove("active");
            const imgEl = modal.querySelector("[data-product-remove-img]");
            if (imgEl && row.dataset.productImg) {
                imgEl.src = row.dataset.productImg;
                imgEl.alt = row.dataset.productTitle || "";
            }
        }

        function open({ drawer, line, row }) {
            const modal = getModal();
            if (!modal || pendingLine !== null) return;
            drawerRef = drawer; pendingLine = line;
            fillWishlist(row);
            modal.hidden = false;
        }

        function close() {
            const modal = getModal();
            if (!modal) return;
            modal.hidden = true; drawerRef = null; pendingLine = null;
        }

        document.addEventListener("click", (e) => {
            const modal = getModal();
            if (!modal || modal.hidden) return;
            const wishlistBtn = getWishlistBtn(modal);
            if (
                e.target.classList.contains("kymee-remove-modal__overlay") ||
                e.target.closest(".kymee-remove-modal__close")
            ) { close(); return; }
            if (e.target.closest("[data-remove-confirm]")) {
                drawerRef?.changeLine(pendingLine, 0); close(); return;
            }
            if (wishlistBtn?.contains(e.target)) {
                e.preventDefault(); e.stopPropagation();
                let list = JSON.parse(localStorage.getItem("wishlist") || "[]");
                const data = {
                    productId: wishlistBtn.dataset.productId,
                    productTitle: wishlistBtn.dataset.productTitle,
                    productImg: wishlistBtn.dataset.productImg,
                    productPrice: wishlistBtn.dataset.productPrice,
                    productUrl: wishlistBtn.dataset.productUrl,
                    productVariant: wishlistBtn.dataset.productVariantId,
                };
                if (!list.some((i) => i.productVariant === data.productVariant)) {
                    list.push(data);
                    localStorage.setItem("wishlist", JSON.stringify(list));
                    document.dispatchEvent(new CustomEvent("wishlist:updated"));
                }
                drawerRef?.changeLine(pendingLine, 0); close();
            }
        });

        return { open };
    })();

    /* ── KymeeCartDrawer Custom Element ──────────────────────── */

    class KymeeCartDrawer extends HTMLElement {
        constructor() {
            super();
            this.isOpen = false;
            this.isRendering = false;
            this.pendingOpen = false;
            this._pendingRefresh = null;
            this.onOverlay = () => this.close();
            this.onClose = () => this.close();
            this.onKey = (e) => { if (e.key === "Escape" && this.isOpen) this.close(); };
            this.onClick = this.onClick.bind(this);
            this.onChange = this.onChange.bind(this);
            // iOS Safari doesn't reliably honor overflow:hidden for locking
            // background scroll — same fix as details-modal.js's search
            // modal: block touchmove outside the drawer's own scrollable
            // content instead of relying on overflow alone.
            this._lastTouchY = 0;
            this._touchStartHandler = this.onTouchStart.bind(this);
            this._touchMoveHandler = this.onTouchMove.bind(this);
        }

        connectedCallback() {
            this.overlayEl = this.querySelector(SELECTORS.overlay);
            this.closeEl = this.querySelector(SELECTORS.close);
            this.contentEl = this.querySelector(SELECTORS.content);
            this.footerEl = this.querySelector(SELECTORS.footer);

            this.overlayEl?.addEventListener("click", this.onOverlay);
            this.closeEl?.addEventListener("click", this.onClose);
            document.addEventListener("keydown", this.onKey);

            document.addEventListener("kymee:cart:added", () => {
                this.switchTab("bag");
                this.open();
                this.refresh({ openIfClosed: false });
            });

            this.addEventListener("click", this.onClick);
            this.addEventListener("change", this.onChange);

            this.querySelectorAll("[data-tab]").forEach((btn) =>
                btn.addEventListener("click", () => this.switchTab(btn.dataset.tab))
            );

            document.querySelector("#cart-icon-bubble")?.addEventListener("click", (e) => {
                e.preventDefault();
                this.switchTab("bag");
                this.open();
            });

            this.onNavCartClick = (e) => {
                if (!e.target.closest("button[data-nav='cart']")) return;
                e.preventDefault();
                this.switchTab("bag");
                this.open();
            };
            document.addEventListener("click", this.onNavCartClick);

            renderRecentlyViewedIfOpen(this);
            setTimeout(initDragScrolls, 50);

            /* 3-7-26 offer change start — register checkout intercept + restore check */
            this._footerCheckoutInterceptBound = this._footerCheckoutIntercept.bind(this);
            document.addEventListener('click', this._footerCheckoutInterceptBound, true);
            this._checkPendingRestore();
            // Restore unselected checkbox state from localStorage on every page load
            requestAnimationFrame(() => initCheckboxes(this));
            /* 3-7-26 offer change end */
        }

        disconnectedCallback() {
            this.overlayEl?.removeEventListener("click", this.onOverlay);
            this.closeEl?.removeEventListener("click", this.onClose);
            document.removeEventListener("keydown", this.onKey);
            document.removeEventListener("click", this.onNavCartClick);
            this.removeEventListener("click", this.onClick);
            this.removeEventListener("change", this.onChange);
            /* 3-7-26 offer change start */
            if (this._footerCheckoutInterceptBound) {
                document.removeEventListener('click', this._footerCheckoutInterceptBound, true);
            }
            /* 3-7-26 offer change end */
        }

        switchTab(tabName) {
            this.querySelectorAll("[data-tab]").forEach((btn) => {
                btn.classList.toggle("is-active", btn.dataset.tab === tabName);
                btn.setAttribute("aria-selected", btn.dataset.tab === tabName ? "true" : "false");
            });
            this.querySelectorAll("[data-tab-panel]").forEach((panel) =>
                panel.classList.toggle("is-hidden", panel.dataset.tabPanel !== tabName)
            );
            if (tabName === "wishlist") renderWishlistTab(this);
        }

        open() {
            if (this.isRendering) this.pendingOpen = true;
            if (this.isOpen) return;
            this.isOpen = true;
            this.classList.add("is-open");
            // Was hardcoded aria-hidden="true" in the markup and never toggled —
            // screen readers were told this region doesn't exist even while it
            // was open and full of focusable buttons/links/inputs.
            this.setAttribute("aria-hidden", "false");
            // inert (not just aria-hidden) is what actually blocks Tab/click
            // from reaching focusable content while the drawer is closed.
            this.removeAttribute("inert");
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
            document.body.classList.add("kymee-drawer-open");
            document.addEventListener("touchstart", this._touchStartHandler, { passive: true });
            document.addEventListener("touchmove", this._touchMoveHandler, { passive: false });
            requestAnimationFrame(() => {
                Urgency.render(this);
                renderRecentlyViewedIfOpen(this);
            });
        }

        close() {
            if (!this.isOpen) return;
            this.isOpen = false;
            this.classList.remove("is-open");
            this.setAttribute("aria-hidden", "true");
            this.setAttribute("inert", "");
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
            document.body.classList.remove("kymee-drawer-open");
            document.removeEventListener("touchstart", this._touchStartHandler);
            document.removeEventListener("touchmove", this._touchMoveHandler);
        }

        onTouchStart(event) {
            this._lastTouchY = event.touches?.[0]?.clientY || 0;
        }

        onTouchMove(event) {
            if (!this.isOpen) return;

            const panel = this.querySelector(".kymee-drawer__panel");

            // Touch outside the drawer panel entirely (eg. the overlay) — block completely
            if (!panel || !panel.contains(event.target)) {
                event.preventDefault();
                return;
            }

            const content = this.contentEl;
            const currentY = event.touches?.[0]?.clientY || 0;
            const deltaY = currentY - this._lastTouchY;
            this._lastTouchY = currentY;

            // Walk up from the touch target to find the innermost scrollable
            // element inside the panel (content area, footer, etc.)
            let scrollEl = event.target;
            while (scrollEl && scrollEl !== panel) {
                if (scrollEl.scrollHeight > scrollEl.clientHeight) break;
                scrollEl = scrollEl.parentElement;
            }
            if (!scrollEl || scrollEl === panel) scrollEl = content || panel;

            const canScroll = scrollEl.scrollHeight > scrollEl.clientHeight;

            if (!canScroll) {
                event.preventDefault();
                return;
            }

            const atTop = scrollEl.scrollTop <= 0;
            const atBottom = Math.ceil(scrollEl.scrollTop + scrollEl.clientHeight) >= scrollEl.scrollHeight;

            // iOS scroll chaining stop — prevent bounce at boundaries
            if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
                event.preventDefault();
            }
        }

        setLoading(state) { this.classList.toggle("is-loading", state); }

        async fetchCart() {
            const res = await fetch("/cart.js", { credentials: "same-origin" });
            return res.json();
        }

        async renderFromSection() {
            const res = await fetch("/?section_id=kymee-cart-drawer");
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, "text/html");
            const fresh = doc.querySelector("kymee-cart-drawer");
            if (!fresh) return;

            this.contentEl.innerHTML = fresh.querySelector(SELECTORS.content)?.innerHTML || "";
            this.footerEl.innerHTML = fresh.querySelector(SELECTORS.footer)?.innerHTML || "";

            const newDesktopWear = fresh.querySelector(".kymee-wear-with-it-desktop__content");
            const oldDesktopWear = this.querySelector(".kymee-wear-with-it-desktop__content");
            if (newDesktopWear && oldDesktopWear) oldDesktopWear.innerHTML = newDesktopWear.innerHTML;

            const newUrgency = fresh.querySelector(SELECTORS.urgency);
            const oldUrgency = this.querySelector(SELECTORS.urgency);
            if (newUrgency && oldUrgency) oldUrgency.outerHTML = newUrgency.outerHTML;
        }

        async refresh({ openIfClosed, cartData = null }) {
            if (this.isRendering) { this._pendingRefresh = { openIfClosed, cartData }; return; }
            this.isRendering = true;

            const prevPercent = Urgency.getPercent(this);

            try {
                this.setLoading(true);

                const cartPromise = cartData ? Promise.resolve(cartData) : this.fetchCart();
                const sectionPromise = this.renderFromSection();
                const cart = await cartPromise;

                if (await removeGiftWrapIfOnlyItem(cart)) {
                    const freshCart = await this.fetchCart();
                    await this.renderFromSection();
                    updateCartCountBubble(freshCart);
                    toggleEmptyState(this, freshCart);
                    syncGiftWrapCheckboxFromCart(freshCart, this);
                    renderRecentlyViewedIfOpen(this);
                    setTimeout(initDragScrolls, 30);
                    return;
                }

                updateCartCountBubble(cart);
                /* 3-7-26 offer change start — keep window.cart fresh for GoKwik */
                window.cart = cart;
                /* 3-7-26 offer change end */
                await sectionPromise;
                toggleEmptyState(this, cart);
                syncGiftWrapCheckboxFromCart(cart, this);
                renderRecentlyViewedIfOpen(this);
                setTimeout(initDragScrolls, 30);

                requestAnimationFrame(() => {
                    Urgency.render(this, prevPercent);
                    /* 3-7-26 offer change start */
                    initCheckboxes(this);
                    /* 3-7-26 offer change end */
                });

                // Update savings from actual Shopify discount data
                const savings = calculateCartSavings(cart);
                const savingsWrap = this.querySelector(SELECTORS.savingsWrap);
                const savingsAmount = this.querySelector(SELECTORS.savingsAmount);
                if (savingsWrap && savingsAmount) {
                    savingsAmount.textContent = savings.toFixed(0);
                    savingsWrap.style.display = savings > 0 ? "block" : "none";
                }

                if (openIfClosed) {
                    this.switchTab("bag");
                    this.open();
                }
                if (this.pendingOpen) { this.pendingOpen = false; this.open(); }

            } catch (err) {
                console.error("[Kymee] drawer refresh error:", err);
            } finally {
                this.setLoading(false);
                this.isRendering = false;
                if (this._pendingRefresh) {
                    const opts = this._pendingRefresh;
                    this._pendingRefresh = null;
                    this.refresh(opts);
                }
            }
        }

        async changeLine(line, quantity) {
            this.setLoading(true);
            try {
                const res = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ line, quantity }),
                });
                const cart = await res.json();
                await this.refresh({ openIfClosed: false, cartData: cart });
            } catch (err) {
                console.error("[Kymee] changeLine error:", err);
                this.setLoading(false);
            }
        }

        onClick(e) {
            // Accordion
            const accordionToggle = e.target.closest("[data-accordion-toggle]");
            if (accordionToggle) {
                const accordion = accordionToggle.closest("[data-accordion]");
                if (accordion) {
                    accordion.classList.toggle("is-open");
                    if (accordion.classList.contains("is-open")) {
                        if (accordion.querySelector("[data-recently-viewed]")) renderRecentlyViewed(this);
                        setTimeout(initDragScrolls, 50);
                    }
                }
                return;
            }

            // Wishlist: Move to Bag
            if (e.target.closest(".kymee-wishlist-move")) {
                const btn = e.target.closest(".kymee-wishlist-move");
                const variantId = btn.dataset.variantId;
                if (!variantId) return;
                btn.textContent = "Adding..."; btn.disabled = true;
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
                })
                    .then((r) => r.json())
                    .then(() => {
                        let list = JSON.parse(localStorage.getItem("wishlist") || "[]");
                        list = list.filter((i) => String(i.productVariant) !== String(variantId));
                        localStorage.setItem("wishlist", JSON.stringify(list));
                        document.dispatchEvent(new CustomEvent("wishlist:updated"));
                        this.switchTab("bag");
                        this.refresh({ openIfClosed: false });
                    })
                    .catch(() => { btn.textContent = "Move to Bag"; btn.disabled = false; });
                return;
            }

            // Wishlist: Remove via card button
            if (e.target.closest(".remove_wishlist")) {
                const btn = e.target.closest(".remove_wishlist");
                if (!btn.closest("[data-tab-panel='wishlist']")) return;
                const productId = btn.dataset.productId;
                if (!productId) return;
                e.stopPropagation();
                let list = JSON.parse(localStorage.getItem("wishlist") || "[]");
                list = list.filter((i) => String(i.productId) !== String(productId));
                localStorage.setItem("wishlist", JSON.stringify(list));
                document.dispatchEvent(new CustomEvent("wishlist:updated"));
                renderWishlistTab(this);
                return;
            }

            /* 3-7-26 offer change start — variant edit */
            if (e.target.closest('[data-edit-item]')) {
                e.preventDefault();
                const itemEl = e.target.closest('[data-line]');
                if (itemEl) this._openVariantEdit(itemEl);
                return;
            }
            /* 3-7-26 offer change end */

            // Cart item actions
            const row = e.target.closest(SELECTORS.item);
            if (!row) return;
            const line = parseInt(row.dataset.line, 10);

            if (e.target.closest(SELECTORS.remove)) {
                e.preventDefault();
                KymeeRemoveModal.open({ drawer: this, line, row });
                return;
            }

            if (e.target.closest(SELECTORS.qtyMinus)) {
                e.preventDefault();
                const input = row.querySelector(SELECTORS.qtyInput);
                const current = parseInt(input.value, 10);
                if (current === 1) { KymeeRemoveModal.open({ drawer: this, line, row }); return; }
                const val = current - 1;
                input.value = val;
                this.changeLine(line, val);
                return;
            }

            if (e.target.closest(SELECTORS.qtyPlus)) {
                e.preventDefault();
                const input = row.querySelector(SELECTORS.qtyInput);
                const val = parseInt(input.value, 10) + 1;
                input.value = val;
                this.changeLine(line, val);
            }
        }

        async handleGiftWrapChange(checkbox) {
            if (!checkbox) return;
            checkbox.disabled = true;
            try {
                if (checkbox.checked) {
                    await fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: GIFT_WRAP_VARIANT_ID, quantity: 1 }),
                    });
                } else {
                    const cart = await this.fetchCart();
                    const giftItem = cart.items.find((i) => i.variant_id === GIFT_WRAP_VARIANT_ID);
                    if (giftItem) {
                        await fetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
                        });
                    }
                }
                await this.refresh({ openIfClosed: false });
            } catch (err) {
                console.error("[Kymee] gift wrap error:", err);
                checkbox.checked = !checkbox.checked;
            } finally {
                checkbox.disabled = false;
            }
        }

        onChange(e) {
            /* 3-7-26 offer change start — checkbox handling */
            if (e.target.matches('[data-select-all]')) {
                const checked = e.target.checked;
                this.querySelectorAll('[data-item-check]').forEach(cb => { cb.checked = checked; });
                if (checked) {
                    try { localStorage.removeItem(SELECTIVE_STORAGE_KEY); } catch {}
                } else {
                    saveUnselectedIds(this);
                }
                updateSelectivePrices(this);
                return;
            }
            if (e.target.matches('[data-item-check]')) {
                saveUnselectedIds(this);
                updateSelectivePrices(this);
                return;
            }
            /* 3-7-26 offer change end */

            if (e.target.matches("[data-gift-wrap-checkbox]")) {
                this.handleGiftWrapChange(e.target);
                return;
            }
            if (!e.target.matches(SELECTORS.qtyInput)) return;
            const row = e.target.closest(SELECTORS.item);
            if (!row) return;
            const line = parseInt(row.dataset.line, 10);
            const val = Math.max(0, parseInt(e.target.value, 10) || 1);
            e.target.value = val;
            this.changeLine(line, val);
        }

        /* 3-7-26 offer change start — selective checkout */
        _footerCheckoutIntercept(e) {
            if (this._allowNextCheckout) { this._allowNextCheckout = false; return; }
            const btn = e.target.closest('button, a[href]');
            if (!btn) return;
            if (!this.footerEl?.contains(btn)) return;
            if (btn.closest('[data-gift-wrap-wrapper]')) return;

            const items = [...this.querySelectorAll('[data-line]')];
            const selected = items.filter(item => {
                const cb = item.querySelector('[data-item-check]');
                return !cb || cb.checked;
            });
            if (selected.length === 0) { e.preventDefault(); e.stopImmediatePropagation(); return; }

            // Block checkout if ONLY Jewel Box items are selected — it cannot be sold alone
            const hasNonJewelBox = selected.some(
                item => item.dataset.productId !== String(JEWEL_BOX_PRODUCT_ID)
            );
            if (!hasNonJewelBox) {
                e.preventDefault();
                e.stopImmediatePropagation();
                showCartToast(this, 'Jewel Box cannot be purchased alone. Please add at least one jewellery item to checkout.');
                return;
            }

            const unselected = items.filter(item => {
                const cb = item.querySelector('[data-item-check]');
                return cb && !cb.checked;
            });
            if (unselected.length === 0) return; // all selected → normal checkout

            e.preventDefault();
            e.stopImmediatePropagation();

            const selectedKeys  = new Set(selected.map(item => item.dataset.key));
            const unselectedIds = new Set(
                unselected.map(item => String(item.dataset.productVariantId || '')).filter(Boolean)
            );
            this._doSelectiveCheckout(btn, selectedKeys, unselectedIds);
        }

        async _doSelectiveCheckout(btn, selectedKeys, unselectedIds) {
            this._cancelPendingRestore?.();
            this._cancelPendingRestore = null;

            // Use cached cart — window.cart is kept fresh on every drawer refresh
            const liveCart = window.cart || await fetch('/cart.js').then(r => r.json());

            const itemsToRemove = liveCart.items.filter(i => !selectedKeys.has(i.key));

            if (itemsToRemove.length === 0) {
                this._allowNextCheckout = true;
                btn.click();
                return;
            }

            const originalOrder = liveCart.items.map(i => String(i.variant_id));

            const restoreItems = itemsToRemove.map(i => {
                const entry = { id: i.variant_id, quantity: i.quantity };
                if (i.properties && Object.keys(i.properties).length) entry.properties = i.properties;
                return entry;
            });
            try {
                localStorage.setItem('kymee-pending-restore', JSON.stringify({
                    items: restoreItems,
                    order: originalOrder,
                    ts: Date.now(),
                }));
            } catch {}

            // Remove all unselected items in ONE request — /cart/update.js is safe for batch qty=0
            this.setLoading(true);
            try {
                const updates = {};
                itemsToRemove.forEach(i => { updates[i.key] = 0; });
                const updatedCart = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates }),
                }).then(r => r.json());
                window.cart = updatedCart;
            } catch (err) {
                console.error('[Kymee] selective remove error:', err);
                try { localStorage.removeItem('kymee-pending-restore'); } catch {}
                this.setLoading(false);
                return;
            }
            this.setLoading(false);

            this._setupAutoRestore(unselectedIds, restoreItems, originalOrder);

            this._allowNextCheckout = true;
            btn.click();
        }

        _setupAutoRestore(unselectedIds, restoreItems, originalOrder) {
            let restored = false;
            let fallbackTimer, msgHandler, obs, gokwikConfirmTimer;

            const cleanup = () => {
                clearTimeout(fallbackTimer);
                clearTimeout(gokwikConfirmTimer);
                window.removeEventListener('message', msgHandler);
                obs?.disconnect();
                if (this._cancelPendingRestore === cleanup) this._cancelPendingRestore = null;
            };
            this._cancelPendingRestore = cleanup;

            const restore = async () => {
                if (restored) return;
                restored = true;
                cleanup();

                // Restore removed items back to Shopify cart
                if (restoreItems?.length) {
                    try {
                        await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ items: restoreItems }),
                        });
                    } catch (err) {
                        console.error('[Kymee] restore items error:', err);
                    }
                }
                try { localStorage.removeItem('kymee-pending-restore'); } catch {}

                // Refresh drawer — initCheckboxes inside refresh re-applies localStorage unselected state
                await this.refresh({ openIfClosed: false });
                this._restoreItemOrder(originalOrder);
            };

            // Trigger 1: GoKwik postMessage
            msgHandler = (e) => {
                const d = (typeof e.data === 'object' && e.data !== null) ? e.data : {};
                const t = String(d.type || d.event || d.action || '').toLowerCase();
                if (t.includes('close') || t.includes('cancel') || t.includes('dismiss') ||
                    t.includes('back') || t.includes('order') || t.includes('success') || t.includes('payment')) {
                    restore();
                }
            };
            window.addEventListener('message', msgHandler);

            // Trigger 2: MutationObserver — GoKwik element added then removed
            const bodyChildrenBefore = new Set([...document.body.children]);
            let gokwikEl = null, gokwikConfirmed = false;
            obs = new MutationObserver(muts => {
                for (const m of muts) {
                    for (const n of m.addedNodes) {
                        if (n.nodeType !== 1 || bodyChildrenBefore.has(n)) continue;
                        if (!gokwikEl) {
                            gokwikEl = n;
                            gokwikConfirmTimer = setTimeout(() => { gokwikConfirmed = true; }, 500);
                        }
                    }
                    for (const n of m.removedNodes) {
                        if (n !== gokwikEl) continue;
                        clearTimeout(gokwikConfirmTimer);
                        if (gokwikConfirmed) { obs.disconnect(); setTimeout(restore, 300); }
                        else { gokwikEl = null; gokwikConfirmed = false; }
                        return;
                    }
                }
            });
            obs.observe(document.body, { childList: true });

            // Trigger 3: 8-min fallback
            fallbackTimer = setTimeout(restore, 8 * 60 * 1000);
        }

        _restoreItemOrder(order) {
            if (!order?.length) return;
            try {
                const container = this.querySelector('.kymee-items');
                if (!container) return;
                const items = [...container.querySelectorAll('[data-line]')];
                if (items.length < 2) return;
                items.sort((a, b) => {
                    const aId = String(a.dataset.productVariantId || '');
                    const bId = String(b.dataset.productVariantId || '');
                    const aIdx = order.indexOf(aId);
                    const bIdx = order.indexOf(bId);
                    const aPos = aIdx === -1 ? order.length : aIdx;
                    const bPos = bIdx === -1 ? order.length : bIdx;
                    return aPos - bPos;
                });
                items.forEach(item => container.appendChild(item));
            } catch {}
        }

        async _checkPendingRestore() {
            try {
                const raw = localStorage.getItem('kymee-pending-restore');
                if (!raw) return;
                const data = JSON.parse(raw);
                if (!data?.items?.length) { localStorage.removeItem('kymee-pending-restore'); return; }
                if (Date.now() - (data.ts || 0) > 2 * 60 * 60 * 1000) {
                    localStorage.removeItem('kymee-pending-restore'); return;
                }
                localStorage.removeItem('kymee-pending-restore');
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: data.items }),
                });
                await this.refresh({ openIfClosed: false });
                if (data.order) this._restoreItemOrder(data.order);
            } catch {}
        }

        /* 3-7-26 offer change start — variant edit quick view */
        async _openVariantEdit(itemEl) {
            const handle = itemEl.dataset.productHandle;
            const lineKey = itemEl.dataset.key;
            const lineNum = parseInt(itemEl.dataset.line, 10);
            const qty = parseInt(itemEl.querySelector('[data-qty-input]')?.value || 1, 10);
            const currentVariantId = parseInt(itemEl.dataset.productVariantId, 10);
            const imgUrl = itemEl.dataset.productImg;

            const modal = this._getOrCreateVariantModal();
            const body = modal.querySelector('.kymee-vedit-modal__body');

            // Skeleton while loading
            body.innerHTML = `
                <div class="kymee-qv">
                    <div class="kymee-qv__img-wrap">
                        ${imgUrl ? `<img id="kymee-qv-main-img" src="${imgUrl}" alt="" class="kymee-qv__img">` : ''}
                    </div>
                    <div class="kymee-qv__info kymee-vedit__loading">
                        <span class="kymee-spinner kymee-spinner--lg"></span>
                    </div>
                </div>`;
            modal.removeAttribute('hidden');
            const bd = document.getElementById('kymee-vedit-backdrop');
            if (bd) bd.style.display = 'block';
            document.body.style.overflow = 'hidden';

            /* 3-7-26 offer change start */
            // Tier 1: kymee-quick-view section (has all product details built in)
            try {
                const res = await fetch(`/products/${handle}?variant=${currentVariantId}&sections=kymee-quick-view`);
                const data = await res.json();
                const html = data['kymee-quick-view'];
                if (!html) throw new Error('no kymee-quick-view section');
                body.innerHTML = html;
                // Re-execute inline scripts (innerHTML doesn't run <script> tags)
                body.querySelectorAll('script:not([type="application/json"])').forEach(old => {
                    const s = document.createElement('script');
                    [...old.attributes].forEach(a => s.setAttribute(a.name, a.value));
                    s.textContent = old.textContent;
                    old.parentNode.replaceChild(s, old);
                });
                this._initQVHandlers(modal, body, lineKey, qty, itemEl, currentVariantId);
                return;
            } catch(e) {
                console.warn('[Kymee QV] Tier 1 failed:', e.message);
            }

            // Tier 2: product.js fallback
            try {
                const product = await fetch(`/products/${handle}.js`).then(r => r.json());
                this._renderQVFallback(modal, body, product, lineKey, qty, currentVariantId, itemEl);
            } catch(e) {
                console.warn('[Kymee QV] Tier 2 failed:', e.message);
                this._closeVariantModal();
            }
            /* 3-7-26 offer change end */
        }

        // Quick view opened from a product card (.open-quick-view in card-product.liquid)
        // — no existing cart line, so this is an "add" not an "edit". Reuses the same
        // modal shell + variant-picker wiring as _openVariantEdit above.
        async _openProductQuickView(handle) {
            const modal = this._getOrCreateVariantModal();
            const body = modal.querySelector('.kymee-vedit-modal__body');

            body.innerHTML = `
                <div class="kymee-qv">
                    <div class="kymee-qv__img-wrap"></div>
                    <div class="kymee-qv__info kymee-vedit__loading">
                        <span class="kymee-spinner kymee-spinner--lg"></span>
                    </div>
                </div>`;
            modal.removeAttribute('hidden');
            const bd = document.getElementById('kymee-vedit-backdrop');
            if (bd) bd.style.display = 'block';
            document.body.style.overflow = 'hidden';

            try {
                const res = await fetch(`/products/${handle}?sections=kymee-quick-view`);
                const data = await res.json();
                const html = data['kymee-quick-view'];
                if (!html) throw new Error('no kymee-quick-view section');
                body.innerHTML = html;
                body.querySelectorAll('script:not([type="application/json"])').forEach(old => {
                    const s = document.createElement('script');
                    [...old.attributes].forEach(a => s.setAttribute(a.name, a.value));
                    s.textContent = old.textContent;
                    old.parentNode.replaceChild(s, old);
                });
                this._initQVHandlers(modal, body, null, 1, null, null, 'add');
                return;
            } catch(e) {
                console.warn('[Kymee QV] product quick view Tier 1 failed:', e.message);
            }

            try {
                const product = await fetch(`/products/${handle}.js`).then(r => r.json());
                this._renderQVFallback(modal, body, product, null, 1, null, null, 'add');
            } catch(e) {
                console.warn('[Kymee QV] product quick view Tier 2 failed:', e.message);
                this._closeVariantModal();
            }
        }

        _getOrCreateVariantModal() {
            // Independent backdrop — direct child of body, no CSS inheritance issues
            if (!document.getElementById('kymee-vedit-backdrop')) {
                const bd = document.createElement('div');
                bd.id = 'kymee-vedit-backdrop';
                bd.style.cssText = 'display:none;position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,0.5);';
                bd.addEventListener('click', () => this._closeVariantModal());
                document.body.appendChild(bd);
            }

            let modal = document.getElementById('kymee-vedit-modal');
            if (!modal) {
                modal = document.createElement('div');
                modal.id = 'kymee-vedit-modal';
                modal.className = 'kymee-vedit-modal';
                modal.setAttribute('hidden', '');
                modal.innerHTML = `
                    <div class="kymee-vedit-modal__box">
                        <button class="kymee-vedit-modal__close" type="button" aria-label="Close">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                        </button>
                        <div class="kymee-vedit-modal__body"></div>
                    </div>`;
                document.body.appendChild(modal);
                modal.querySelector('.kymee-vedit-modal__close').addEventListener('click', () => this._closeVariantModal());
            }
            return modal;
        }

        _initQVHandlers(modal, body, lineKey, qty, itemEl, currentVariantId, mode = 'edit') {
            // Read embedded variant data from section
            let variants = [];
            try {
                const dataEl = body.querySelector('#kymee-qv-data');
                if (dataEl) variants = JSON.parse(dataEl.textContent).variants || [];
            } catch {}

            // itemEl is null in 'add' mode (quick view opened from a product card,
            // not an existing cart line) — there's no line to reference yet.
            const lineNum = itemEl ? parseInt(itemEl.dataset.line, 10) : null;
            const currentVariant = variants.find(v => v.id === currentVariantId) || variants[0];
            const selectedOpts = currentVariant ? [...currentVariant.options] : [];
            modal._veditData = { variants, lineKey, lineNum, qty, selectedOpts, itemEl, mode };

            // 'add' mode (quick view opened from a product card, no existing cart
            // line): don't treat the default/first variant as already "selected".
            // Only options with no rendered fieldset here (Color/Material/Metal —
            // skipped entirely by kymee-quick-view.liquid) or ones the server
            // actually pre-checked (single-value options, via
            // product-variant-options.liquid) keep their default value; every
            // other option resets to null until the shopper explicitly picks one.
            if (mode === 'add') {
                body.querySelectorAll('[data-sel-oi]').forEach(selSpan => {
                    const oi = parseInt(selSpan.dataset.selOi, 10);
                    const fieldset = selSpan.closest('fieldset');
                    const checkedRadio = fieldset?.querySelector('input[type="radio"]:checked');
                    selectedOpts[oi] = checkedRadio ? checkedRadio.value : null;
                    if (!checkedRadio && selSpan) selSpan.textContent = '';
                });
            }

            const fmt = p => '₹' + Math.floor(p / 100).toLocaleString('en-IN');

            const onOptChange = (oi, val) => {
                modal._veditData.selectedOpts[oi] = val;
                const selLabel = body.querySelector(`[data-sel-oi="${oi}"]`);
                if (selLabel) selLabel.textContent = val;
                // Toggle is-selected on button chips (fallback HTML)
                body.querySelectorAll(`button[data-oi="${oi}"]`).forEach(b =>
                    b.classList.toggle('is-selected', b.dataset.val === val));
                // Update price + image for matching variant
                const { variants: vlist, selectedOpts: so } = modal._veditData;
                const match = vlist.find(v => v.options.every((o, i) => o === so[i]));
                if (match) {
                    const priceRow = body.querySelector('#kymee-qv-price');
                    if (priceRow) {
                        let html = `<span class="kymee-qv__price">${fmt(match.price)}</span>`;
                        if (match.compare_at_price > match.price) {
                            const pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
                            html += `<s class="kymee-qv__compare">${fmt(match.compare_at_price)}</s>`;
                            // html += `<span class="kymee-qv__off-badge">${pct}% Off</span>`;
                        }
                        priceRow.innerHTML = html;
                    }
                    if (match.featured_image?.src) {
                        const img = body.querySelector('#kymee-qv-main-img');
                        if (img) img.src = match.featured_image.src;
                    }
                }
            };

            // Radio inputs — grouped by each option's [data-sel-oi] label span,
            // since the real theme variant-picker markup (product-variant-options.liquid,
            // used by kymee-quick-view.liquid) has no data-oi/data-val attributes —
            // only name/value/id. The fallback-generated HTML also carries
            // [data-sel-oi] on its label span, so this covers both tiers.
            body.querySelectorAll('[data-sel-oi]').forEach(selSpan => {
                const oi = parseInt(selSpan.dataset.selOi, 10);
                const fieldset = selSpan.closest('fieldset');
                if (!fieldset) return;
                fieldset.querySelectorAll('input[type="radio"]').forEach(radio => {
                    radio.addEventListener('change', () => onOptChange(oi, radio.value));
                });
            });
            // Button chips — fallback HTML
            body.querySelectorAll('button[data-oi]').forEach(btn => {
                btn.addEventListener('click', () =>
                    onOptChange(parseInt(btn.dataset.oi, 10), btn.dataset.val));
            });

            const updateBtn = body.querySelector('[data-vedit-update]');
            if (updateBtn) {
                if (mode === 'add') {
                    updateBtn.textContent = 'Add to Cart';
                    updateBtn.addEventListener('click', () => {
                        // Same native "please select an option" validation the real
                        // product page uses — required radios (product-variant-options.liquid)
                        // are associated with this form via their `form="..."` attribute,
                        // not physical nesting, so checkValidity()/reportValidity() here
                        // covers them even though the form itself renders empty.
                        const form = body.querySelector('[data-kymee-qv-variant-form]');
                        if (form && !form.checkValidity()) {
                            form.reportValidity();
                            return;
                        }
                        this._doVariantAdd(modal);
                    });
                } else {
                    updateBtn.addEventListener('click', () => this._doVariantUpdate(modal));
                }
            }

            // Pre-fill personalization inputs from existing cart item properties
            itemEl?.querySelectorAll('.kymee-property').forEach(p => {
                const key = p.querySelector('.kymee-property__label')?.textContent?.replace(':', '').trim();
                const val = p.querySelector('.kymee-property__value')?.textContent?.trim();
                if (!key || !val) return;
                body.querySelectorAll(`[data-property-key="${CSS.escape(key)}"]`).forEach(input => {
                    if (input.type === 'radio') {
                        if (input.value === val) input.checked = true;
                    } else {
                        input.value = val;
                    }
                });
            });
        }

        // Fallback when section rendering fails — build from product.js data
        _renderQVFallback(modal, body, product, lineKey, qty, currentVariantId, itemEl, mode = 'edit') {
            const currentVariant = product.variants.find(v => v.id === currentVariantId) || product.variants[0];
            const selectedOpts = [...(currentVariant?.options || [])];
            // product.options can be string[] or object[] depending on Shopify API version
            const optsWithVals = product.options.map((opt, i) => ({
                name: typeof opt === 'string' ? opt : (opt.name || `Option ${i + 1}`),
                values: [...new Set(product.variants.map(v => v[`option${i + 1}`]).filter(Boolean))],
            }));

            // 'add' mode: same rule as _initQVHandlers — an option with only one
            // possible value stays auto-selected, anything with more than one
            // value must be explicitly picked before Add to Cart works.
            if (mode === 'add') {
                optsWithVals.forEach((opt, oi) => {
                    if (opt.values.length > 1) selectedOpts[oi] = null;
                });
            }

            modal._veditData = { variants: product.variants, lineKey, qty, selectedOpts, itemEl, mode };

            const fmt = p => '₹' + Math.floor(p / 100).toLocaleString('en-IN');
            const priceHtml = (v) => {
                let h = `<span class="kymee-qv__price">${fmt(v.price)}</span>`;
                if (v.compare_at_price > v.price) {
                    const pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
                    h += `<s class="kymee-qv__compare">${fmt(v.compare_at_price)}</s>`;
                    // h += `<span class="kymee-qv__off-badge">${pct}% Off</span>`;
                }
                return h;
            };
            const imgSrc = currentVariant?.featured_image?.src || product.featured_image?.src || '';

            const optsHtml = optsWithVals.map((opt, oi) => {
                const requireThis = mode === 'add' && opt.values.length > 1;
                const radiosHtml = opt.values.map((val, vi) => {
                    const testOpts = [...selectedOpts]; testOpts[oi] = val;
                    const match = product.variants.find(v => v.options.every((o, i) => o === testOpts[i]));
                    const unavail = !match || match.available === false;
                    const id = `kymee-qv-fb-${oi}-${vi}`;
                    return `<input type="radio" id="${id}" name="kymee-qv-fb-opt-${oi}" value="${val}"
                        data-oi="${oi}" data-val="${val}" form="kymee-qv-fb-form"
                        ${requireThis ? 'required' : ''}
                        ${selectedOpts[oi] === val ? 'checked' : ''}
                        ${unavail ? 'class="disabled"' : ''}>
                    <label for="${id}">${val}</label>`;
                }).join('');
                return `<fieldset class="js product-form__input product-form__input--pill">
                    <div class="input_wrapper">
                        <div class="variant-label">
                            <legend class="form__label">${opt.name} : <span data-sel-oi="${oi}" data-selected-value style="color:#373636;">${selectedOpts[oi] || ''}</span></legend>
                        </div>
                        <div class="input_inner scroll1">${radiosHtml}</div>
                    </div>
                </fieldset>`;
            }).join('');

            body.innerHTML = `
                <div class="kymee-qv">
                    <div class="kymee-qv__img-wrap">${imgSrc ? `<img id="kymee-qv-main-img" src="${imgSrc}" alt="" class="kymee-qv__img">` : ''}</div>
                    <div class="kymee-qv__info">
                        <div class="kymee-qv__price-row" id="kymee-qv-price">${priceHtml(currentVariant || product.variants[0])}</div>
                        <h2 class="product__title kymee-qv__title">${product.title}</h2>
                        <div class="gold-vermeil">18K Gold Vermeil on 925 Sterling Silver</div>
                        <div class="kymee-qv__opts">${optsHtml}</div>
                        <form id="kymee-qv-fb-form" data-kymee-qv-variant-form onsubmit="return false;"></form>
                        <button type="button" class="button button--full-width button--primary" data-vedit-update>Update Cart</button>
                    </div>
                    <script type="application/json" id="kymee-qv-data">${JSON.stringify({ variants: product.variants }).replace(/</g, '\\u003c')}<\/script>
                </div>`;

            this._initQVHandlers(modal, body, lineKey, qty, itemEl, currentVariantId, mode);
        }

        _closeVariantModal() {
            const modal = document.getElementById('kymee-vedit-modal');
            if (modal) modal.setAttribute('hidden', '');
            const bd = document.getElementById('kymee-vedit-backdrop');
            if (bd) bd.style.display = 'none';
            document.body.style.overflow = '';
        }

        async _doVariantUpdate(modal) {
            const { variants, lineKey, lineNum, qty, selectedOpts, itemEl } = modal._veditData || {};
            if (!variants?.length) return;

            const newVariant = variants.find(v => v.options.every((o, i) => o === selectedOpts[i]));
            if (!newVariant) return;

            const updateBtn = modal.querySelector('[data-vedit-update]');
            if (updateBtn) { updateBtn.disabled = true; updateBtn.textContent = 'Updating...'; }

            // Collect existing line item properties (skip GoKwik internal _ props)
            const props = {};
            itemEl?.querySelectorAll('.kymee-property').forEach(p => {
                const label = p.querySelector('.kymee-property__label')?.textContent?.replace(':', '').trim();
                const value = p.querySelector('.kymee-property__value')?.textContent?.trim();
                if (label && value && !label.startsWith('_')) props[label] = value;
            });
            // Override with any new values from quick view personalization inputs
            modal.querySelectorAll('[data-property-key]').forEach(input => {
                const key = input.dataset.propertyKey;
                if (!key) return;
                if (input.type === 'radio' && !input.checked) return;
                const val = input.value?.trim();
                if (val) props[key] = val;
            });

            try {
                // Step 1: remove old item first (by line number — most reliable)
                // Use lineKey as fallback if lineNum not available
                const removeBody = lineNum
                    ? { line: lineNum, quantity: 0 }
                    : { id: lineKey, quantity: 0 };
                const removeRes = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(removeBody),
                });
                if (!removeRes.ok) throw new Error('remove failed: ' + removeRes.status);

                // Step 2: add new variant
                const addRes = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: newVariant.id, quantity: qty, properties: props }),
                });
                if (!addRes.ok) throw new Error('add failed: ' + addRes.status);
            } catch (err) {
                console.error('[Kymee] variant update error:', err);
                if (updateBtn) { updateBtn.disabled = false; updateBtn.textContent = 'Update Cart'; }
                return;
            }

            this._closeVariantModal();
            await this.refresh({ openIfClosed: false });
        }

        // "Add to Cart" for quick view opened from a product card (no existing
        // cart line — see _openProductQuickView). Dispatching kymee:cart:added
        // is enough to make the drawer open + refresh itself (see the listener
        // registered in connectedCallback), so no manual refresh() call here.
        async _doVariantAdd(modal) {
            const { variants, selectedOpts, qty } = modal._veditData || {};
            if (!variants?.length) return;

            const newVariant = variants.find(v => v.options.every((o, i) => o === selectedOpts[i]));
            if (!newVariant) return;

            const addBtn = modal.querySelector('[data-vedit-update]');
            if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding...'; }

            const props = {};
            modal.querySelectorAll('[data-property-key]').forEach(input => {
                const key = input.dataset.propertyKey;
                if (!key) return;
                if (input.type === 'radio' && !input.checked) return;
                const val = input.value?.trim();
                if (val) props[key] = val;
            });

            try {
                const addRes = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: newVariant.id, quantity: qty || 1, properties: props }),
                });
                if (!addRes.ok) throw new Error('add failed: ' + addRes.status);
            } catch (err) {
                console.error('[Kymee QV] add to cart error:', err);
                if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
                return;
            }

            this._closeVariantModal();
            document.dispatchEvent(new CustomEvent('kymee:cart:added'));
        }
        /* 3-7-26 offer change end */
    }

    if (!customElements.get("kymee-cart-drawer")) {
        customElements.define("kymee-cart-drawer", KymeeCartDrawer);
    }

    /* ── Quick view trigger from product cards ──────────────────
       .open-quick-view (card-product.liquid) lives wherever product cards
       render — collection grids, search, recently viewed, wishlist — not
       necessarily inside <kymee-cart-drawer>, so this is a global delegated
       listener rather than something wired inside the component itself. */
    document.addEventListener("click", (e) => {
        const trigger = e.target.closest(".open-quick-view");
        if (!trigger) return;
        e.preventDefault();
        const handle = trigger.dataset.productHandle;
        if (!handle) return;
        const drawer = document.querySelector("kymee-cart-drawer");
        drawer?._openProductQuickView(handle);
    });

    /* ── Drag-to-scroll ──────────────────────────────────────── */

    function enableDragScroll(el) {
        let isDown = false, startX = 0, scrollStart = 0, hasMoved = false, lastX = 0, velocity = 0, rafId = null;
        el.addEventListener("mousedown", (e) => {
            if (e.button !== 0) return;
            isDown = true; hasMoved = false; startX = e.pageX; lastX = e.pageX;
            scrollStart = el.scrollLeft; velocity = 0;
            if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
            e.preventDefault();
        });
        document.addEventListener("mousemove", (e) => {
            if (!isDown) return;
            if (Math.abs(e.pageX - startX) > 5) hasMoved = true;
            velocity = e.pageX - lastX; lastX = e.pageX;
            el.scrollLeft = scrollStart - (e.pageX - startX);
        });
        document.addEventListener("mouseup", () => {
            if (!isDown) return;
            isDown = false;
            let vel = -velocity;
            const coast = () => {
                if (Math.abs(vel) < 0.5) return;
                el.scrollLeft += vel; vel *= 0.88;
                rafId = requestAnimationFrame(coast);
            };
            coast();
        });
        el.addEventListener("click", (e) => {
            if (hasMoved) { e.preventDefault(); e.stopImmediatePropagation(); hasMoved = false; }
        }, true);
    }

    function initDragScrolls() {
        document.querySelectorAll(".kymee-wear-with-it_ul, .kymee-rv-list").forEach((el) => {
            if (el.dataset.dragInit) return;
            el.dataset.dragInit = "1";
            enableDragScroll(el);
        });
    }

    initDragScrolls();

    /* ── Urgency event → confetti + GTM ─────────────────────── */

    document.addEventListener("kymee:discount:urgency", (e) => {
        fireCanvasConfetti();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "discount_applied_urgency",
            urgency_step: e.detail.step,
            urgency_percent: e.detail.percent,
        });
    });

    /* ── Wishlist count badge ────────────────────────────────── */

    document.addEventListener("wishlist:updated", () => {
        const list = JSON.parse(localStorage.getItem("wishlist") || "[]");
        document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
            el.textContent = list.length;
            el.style.display = list.length ? "" : "none";
        });
        const drawer = document.querySelector("kymee-cart-drawer");
        const wlPanel = drawer?.querySelector("[data-tab-panel='wishlist']");
        if (wlPanel && !wlPanel.classList.contains("is-hidden")) renderWishlistTab(drawer);
    });

    /* ── Wishlist icon → open drawer ────────────────────────── */

    document.addEventListener("click", (e) => {
        const wlLink = e.target.closest('a[href="/pages/custom-wishlist"], .wishlist-icon');
        if (!wlLink) return;
        e.preventDefault();
        const drawer = document.querySelector("kymee-cart-drawer");
        if (!drawer) return;
        drawer.open();
        drawer.switchTab("wishlist");
    });

    /* ── Init wishlist count badge on page load ─────────────── */
    (function () {
        const list = JSON.parse(localStorage.getItem("wishlist") || "[]");
        document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
            el.textContent = list.length;
            el.style.display = list.length ? "" : "none";
        });
    })();

    /* ── Dawn cartUpdate binding ────────────────────────────── */

    (function bindKymeeCartUpdate(retry = 0) {
        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                const cart = event.cartData;
                if (!cart || typeof cart.item_count !== "number") return;
                updateCartCountBubble(cart);
                const drawer = document.querySelector("kymee-cart-drawer");
                if (drawer?.isOpen) {
                    drawer.refresh({ openIfClosed: false });
                }
            });
        } else if (retry < 10) {
            setTimeout(() => bindKymeeCartUpdate(retry + 1), 50);
        }
    })();

})();
